<script lang="ts" setup>
  import type { SupportedLocale } from '~/types/localization'
  import { useQuery } from '@tanstack/vue-query'
  import { useApi } from '~/api'

  const api = useApi()
  const { locale, mergeLocaleMessage } = useI18n()
  const authStore = useAuthStore()
  const { activeLicence } = storeToRefs(authStore)

  const hasActiveLicence = computed(() => !!activeLicence.value)

  // Keep this reactive (no .value snapshots) so locale/licence changes get their own cache entry.
  const queryKey = computed(() => ['localizations', locale.value, String(activeLicence.value?.id)])

  const { data: translationData, status } = useQuery({
    queryKey,
    queryFn: () => {
      const lang = locale.value as SupportedLocale
      return api.localization.getLocalizationsByLang(lang).then((messages) => ({ lang, messages }))
    },
    enabled: hasActiveLicence // Custom Translations are at Licence Level
  })

  watch(
    [translationData, status],
    ([result, currentStatus]) => {
      if (currentStatus === 'success' && result) {
        mergeLocaleMessage(result.lang, result.messages)
      } else if (currentStatus === 'error') {
        console.error(`Failed to load translations for ${locale.value}`)
      }
    },
    { immediate: true }
  )
</script>

<template>
  <div></div>
</template>

<style scoped></style>
